import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { UpdateRadParticipantInput } from '../../lib/types/models/rad/update-rad-affected-staff'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateRadAffectedStaff(
  data: UpdateInput<UpdateRadParticipantInput> & { participantId: number }
) {
  const { id, participantId, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API.rads.updateRadParticipant.url, { id, participantId }))
    .patch<AffectedStaff, Partial<UpdateRadParticipantInput>>(rest)
}
